import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userSettingsConstant, ViewOthersInboxModalConstants } from "../../../../../src/Core/Common/Constants";
import { IDelegateeUser } from "../../../../../src/Core/ViewModels/User/UserViewModel";
import { ApplicationState } from "../../../../../src/store";
import SearchInput from "../../SearchComponent/SearchComponent";
import { Loader } from "react-overlay-loader";
import { getLeftSideMenuData, saveMailboxUserToStore } from "../../../../../src/actionCreators/commonActionCreators";
import { useNavigate } from "react-router";
import { CustomModal } from "../CustomModal";
interface IViewInboxModalProps {
    showViewInboxModal: boolean;
    clearModalState: () => void;
}

export const ViewInboxModal: React.FC<IViewInboxModalProps> = ({ showViewInboxModal, clearModalState }) => {
    const dispatch = useDispatch();
    const [list, setList] = useState<IDelegateeUser[]>([]);
    const [searchText, setSearchText] = useState<string>("");
    const { mailboxUserList, isLoading } = useSelector((state: ApplicationState) => state.commonState);
    const navigate = useNavigate();

    useEffect(() => {
        setList(mailboxUserList);
    }, [mailboxUserList]);

    const getName = (user: IDelegateeUser): string => `${user?.firstName} ${user?.lastName || ""}`;
    const onFilter: React.ChangeEventHandler<HTMLInputElement> = e => {
        const value = e.target.value;
        setSearchText(value);
        const filteredList = mailboxUserList.filter(data =>
            `${getName(data).toLocaleLowerCase()}`.includes(value.toLocaleLowerCase())
        );
        setList(filteredList);
    };

    const handleOtherUserListClick = (user: IDelegateeUser) => {
        dispatch(saveMailboxUserToStore(user));
        dispatch(getLeftSideMenuData());
        navigate("/");
        clearModalState();
    };

    return (
        <CustomModal
            show={showViewInboxModal}
            onHide={() => {
                clearModalState();
            }}
            className="add-sender-modal"
            hideFooter={true}
            title={ViewOthersInboxModalConstants.MODAL_TITLE}
        >
         
            <div>
                <div className="padding-top-bottom-2 padding-left-right-3 mb-2 dropdown-search">
                    <SearchInput placeholder="Search" value={searchText} onChange={onFilter} />
                </div>
                <div className="search-list-wrapper">
                    {list?.length ? (
                        list.map((data, index) => (
                            <p
                                title={getName(data)}
                                onClick={() => handleOtherUserListClick(data)}
                                className="truncate"
                                key={index}
                                data-email={data.email}
                            >
                                {getName(data)}
                            </p>
                        ))
                    ) : (
                        <p>{userSettingsConstant.NO_DELEGATEE_TEXT}</p>
                    )}
                </div>
                <Loader loading={isLoading} />
            </div>
        </CustomModal>
    );
};
